var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"no-close-on-backdrop":true,"id":"test-modal","size":"xl","hide-footer":"","title":"Create Invoice"}},[_vm._v(" Hi "+_vm._s(_vm.test)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }